export function createServerPlugin(pluginConfig, serverPlugin) {
    return {
        config: pluginConfig,
        ...serverPlugin,
    };
}
